exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".from[data-v-500dc592]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding-bottom:20px;border-bottom:1px solid #eeeeee}.info[data-v-500dc592]{color:#1890ff;cursor:pointer}.card-box[data-v-500dc592]{min-height:calc(100vh - 65px)}.frame-name .iconfont[data-v-500dc592]{padding-right:6px}.icon-h[data-v-500dc592]{position:relative}.icon-h>span[data-v-500dc592]{color:#1890ff}.box[data-v-500dc592]{padding:20px}\n", ""]);

// exports
